/* EI: Bulk savings estimator (homepage redesign 2026-10).
   Progressive enhancement only: the section is fully server-rendered for a default quantity.
   This script recalculates the numbers when the quantity changes. No dependencies.
   Perf: nothing runs at page load except one IntersectionObserver; the estimator wakes up about a
   screen before it scrolls into view (or on the first touch/focus inside it), and only writes the
   DOM where a value actually changes. */
(function () {
  'use strict';

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function still() {
    return (mq && mq.matches) || !!(navigator.connection && navigator.connection.saveData);
  }
  var MAX_QTY = 1000;

  function setText(el, s) { s = String(s); if (el.textContent !== s) el.textContent = s; }
  function setAttr(el, k, v) { if (el.getAttribute(k) !== v) el.setAttribute(k, v); }
  function setHidden(el, v) { if (el.hidden !== v) el.hidden = v; }

  /* Sections marked data-ei-cv use content-visibility: auto, so one that has not been shown yet only
     holds an estimated height. Render the ones above the target first so the scroll lands exactly. */
  function settle(target) {
    var cv = document.querySelectorAll('[data-ei-cv]');
    for (var i = 0; i < cv.length; i++) {
      if (cv[i].compareDocumentPosition(target) & 4) cv[i].style.contentVisibility = 'visible';
    }
  }

  function init(root) {
    if (root.__eiBs) return;
    root.__eiBs = true;
    if (io) io.unobserve(root);
    ['pointerdown', 'focusin', 'keydown'].forEach(function (t) { root.removeEventListener(t, wake, true); });

    var ds = root.dataset;
    var price = parseInt(ds.price || '0', 10) || 0;
    var fee = parseInt(ds.fee || '0', 10) || 0;
    var feeText = ds.feeText || '';
    var waive = parseInt(ds.waive || '12', 10);
    var rmax = parseInt(ds.max || '150', 10);
    var fmt;
    try {
      fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: ds.currency || 'USD' });
    } catch (e) {
      fmt = { format: function (v) { return '$' + v.toFixed(2); } };
    }
    function money(cents) { return fmt.format(Math.round(cents) / 100); }

    var tiers = [].slice.call(root.querySelectorAll('[data-bs-tier]')).map(function (el) {
      return { min: parseInt(el.dataset.min, 10) || 1, pct: parseFloat(el.dataset.pct) || 0, label: el.dataset.label || '', el: el };
    }).sort(function (a, b) { return a.min - b.min; });
    if (!tiers.length) return;

    function $(name) { return root.querySelector('[data-bs="' + name + '"]'); }
    var num = root.querySelector('[data-bs-num]');
    var range = root.querySelector('[data-bs-range]');
    var steps = [].slice.call(root.querySelectorAll('[data-bs-step]'));
    var jump = root.querySelector('[data-bs-jump]');
    var ticks = [].slice.call(root.querySelectorAll('[data-bs-tick]'));
    var out = {
      tier: $('tier'), was: $('was'), unit: $('unit'), unit2: $('unit2'), qty: $('qty'), sub: $('sub'),
      fee: $('fee'), feewas: $('feewas'), total: $('total'), save: $('save'), saveYes: $('save-yes'),
      saveNo: $('save-no'), nudge: $('nudge'), live: $('live')
    };
    var nudgeBox = out.nudge ? out.nudge.parentNode : null;
    if (!num || !range) return;

    function calc(n) {
      var t = { min: 1, pct: 0, label: tiers[0].label, el: null };
      var next = null;
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].min <= n) t = tiers[i];
        else if (!next) next = tiers[i];
      }
      var gross = price * n;
      var disc = Math.round(gross * t.pct / 100);
      var sub = gross - disc;
      var feeNow = n >= waive ? 0 : fee;
      return {
        n: n, t: t, next: next,
        unit: Math.round(price * (100 - t.pct) / 100),
        sub: sub, fee: feeNow, total: sub + feeNow,
        save: disc + (fee - feeNow)
      };
    }

    /* Number tween (<= 260ms). Reduced motion or Save-Data: instant. */
    var shown = {};
    var raf = 0;
    function tween(targets) {
      if (raf) cancelAnimationFrame(raf);
      var keys = Object.keys(targets).filter(function (k) { return out[k]; });
      var moving = keys.some(function (k) { return shown[k] != null && shown[k] !== targets[k]; });
      if (!moving || still() || !window.requestAnimationFrame) {
        raf = 0;
        keys.forEach(function (k) { shown[k] = targets[k]; setText(out[k], money(targets[k])); });
        return;
      }
      var from = {};
      keys.forEach(function (k) { from[k] = shown[k] == null ? targets[k] : shown[k]; });
      var t0 = 0;
      var dur = 260;
      function frame(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        keys.forEach(function (k) {
          var v = from[k] + (targets[k] - from[k]) * e;
          shown[k] = p === 1 ? targets[k] : v;
          setText(out[k], money(shown[k]));
        });
        raf = p < 1 ? requestAnimationFrame(frame) : 0;
      }
      raf = requestAnimationFrame(frame);
    }

    function pulse(el) {
      if (!el || still() || !el.animate) return;
      el.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.08)' }, { transform: 'scale(1)' }],
        { duration: 220, easing: 'cubic-bezier(.2,.7,.2,1)' }
      );
    }

    var current = null;
    var liveTimer = 0;

    function render(n, opts) {
      opts = opts || {};
      var r = calc(n);
      var tierChanged = !current || current.t !== r.t;

      /* Controls */
      if (!opts.fromNum && String(num.value) !== String(n)) num.value = n;
      var rv = Math.min(n, rmax);
      if (String(range.value) !== String(rv)) range.value = rv;
      var rp = ((rv - 1) / Math.max(1, rmax - 1)).toFixed(4);
      if (range.style.getPropertyValue('--r') !== rp) range.style.setProperty('--r', rp);
      setAttr(range, 'aria-valuetext', n + (n === 1 ? ' item, ' : ' items, ') + r.t.label);
      steps.forEach(function (b) {
        var d = parseInt(b.dataset.bsStep, 10);
        var dis = d < 0 ? n <= 1 : n >= MAX_QTY;
        if (b.disabled !== dis) b.disabled = dis;
      });
      ticks.forEach(function (tk) { tk.classList.toggle('is-on', parseInt(tk.dataset.bsTick, 10) <= n); });

      /* Ladder */
      if (tierChanged) {
        tiers.forEach(function (t) {
          var on = t === r.t;
          t.el.classList.toggle('is-active', on);
          if (on) setAttr(t.el, 'aria-current', 'true');
          else t.el.removeAttribute('aria-current');
        });
        if (out.tier) {
          setText(out.tier, r.t.label);
          out.tier.classList.toggle('is-base', r.t.pct === 0);
          if (current) pulse(out.tier);
        }
      }

      /* Receipt */
      if (out.qty) setText(out.qty, n);
      if (out.was) setHidden(out.was, r.t.pct === 0);
      if (out.feewas) setHidden(out.feewas, r.fee > 0);
      if (out.fee) {
        setText(out.fee, r.fee > 0 ? money(r.fee) : 'Waived');
        out.fee.parentNode.classList.toggle('is-waived', r.fee === 0);
      }
      if (price) {
        tween({ unit: r.unit, unit2: r.unit, sub: r.sub, total: r.total, save: r.save });
        if (out.saveYes) setHidden(out.saveYes, r.save <= 0);
        if (out.saveNo) setHidden(out.saveNo, r.save > 0);
      }

      /* Nudge */
      if (out.nudge) {
        var txt;
        if (r.next) {
          var k = r.next.min - n;
          txt = 'Add ' + k + ' more to reach ' + r.next.label;
          if (r.fee > 0 && r.next.min >= waive && feeText) txt += ' and skip the ' + feeText + ' digitizing fee';
          txt += '.';
          if (price) {
            var nt = calc(r.next.min).total;
            if (nt < r.total) txt += ' Your total drops to ' + money(nt) + '.';
          }
          if (jump) {
            setHidden(jump, false);
            setAttr(jump, 'data-bs-jump', String(r.next.min));
            setText(jump, 'Try ' + r.next.min);
            setAttr(jump, 'aria-label', 'Set quantity to ' + r.next.min);
          }
          if (nudgeBox) {
            nudgeBox.classList.toggle('is-close', k <= 5);
            nudgeBox.classList.remove('is-top');
          }
        } else {
          txt = 'You\'re at the top discount: ' + r.t.label + ' every item' + (r.fee === 0 ? ', digitizing fee waived.' : '.');
          if (jump) {
            if (document.activeElement === jump) num.focus();
            setHidden(jump, true);
          }
          if (nudgeBox) {
            nudgeBox.classList.add('is-top');
            nudgeBox.classList.remove('is-close');
          }
        }
        setText(out.nudge, txt);
      }

      /* Screen reader summary, after the value settles */
      if (out.live && current) {
        clearTimeout(liveTimer);
        liveTimer = setTimeout(function () {
          var s = n + (n === 1 ? ' item: ' : ' items: ') + r.t.label;
          if (price) s += ', ' + money(r.unit) + ' each';
          s += ', digitizing fee ' + (r.fee > 0 ? money(r.fee) : 'waived') + '.';
          if (price) s += ' Estimated total ' + money(r.total) + '.';
          out.live.textContent = s;
        }, 500);
      }

      current = r;
    }

    function clamp(v) {
      v = Math.round(v);
      if (!isFinite(v) || v < 1) return 1;
      return v > MAX_QTY ? MAX_QTY : v;
    }

    range.addEventListener('input', function () { render(clamp(parseInt(range.value, 10))); });
    num.addEventListener('input', function () {
      var v = parseInt(num.value, 10);
      if (isFinite(v) && v >= 1) render(clamp(v), { fromNum: v <= MAX_QTY });
    });
    num.addEventListener('change', function () { render(clamp(parseInt(num.value, 10))); });
    num.addEventListener('blur', function () { if (String(num.value) !== String(current.n)) num.value = current.n; });
    steps.forEach(function (b) {
      b.addEventListener('click', function () {
        render(clamp(current.n + parseInt(b.dataset.bsStep, 10)));
      });
    });
    if (jump) {
      jump.addEventListener('click', function () {
        var to = parseInt(jump.dataset.bsJump, 10);
        if (to) render(clamp(to));
      });
    }

    /* Smooth-scroll in-page links (e.g. #shop-by-category); native jump if the target is missing. */
    root.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      var target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      settle(target);
      target.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'start' });
      if (history.pushState) history.pushState(null, '', '#' + id);
    });

    /* Seed tween state from the server-rendered default. */
    var start = clamp(parseInt(num.value, 10) || 24);
    var r0 = calc(start);
    shown = { unit: r0.unit, unit2: r0.unit, sub: r0.sub, total: r0.total, save: r0.save };
    render(start);
  }

  /* In-page links (#id) scroll natively (the theme makes that smooth). Settle the estimated sections
     above the target first, so the browser computes the final spot from real heights. Registered once. */
  if (!window.__eiCvLinks) {
    window.__eiCvLinks = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a || !a.hash || a.hash.length < 2 || a.href.split('#')[0] !== location.href.split('#')[0]) return;
      var t;
      try { t = document.getElementById(decodeURIComponent(a.hash.slice(1))); } catch (err) { return; }
      if (t) settle(t);
    }, true);
  }

  /* Lazy start: one shared observer wakes each estimator about a screen before it is visible.
     A touch, click or focus inside it wakes it at once, before the event reaches the controls. */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { io.unobserve(e.target); init(e.target); }
    });
  }, { rootMargin: '100% 0px' }) : null;

  function wake(e) { init(e.currentTarget); }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-ei-bs]'), function (root) {
      if (root.__eiBs || root.__eiBsWait) return;
      if (!io) { init(root); return; }
      root.__eiBsWait = true;
      io.observe(root);
      ['pointerdown', 'focusin', 'keydown'].forEach(function (t) { root.addEventListener(t, wake, true); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Theme editor: re-init when the section is re-rendered. */
  document.addEventListener('shopify:section:load', boot);
})();
